import { AxiosError, AxiosResponse } from 'axios';
import ErrorAlert from 'components/shared/ErrorAlert';
import Spinner from 'components/shared/Spinner';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosHelper from 'services/AxiosHelper';
import entityDefinition from '../../Definition';

/**
 * Recovery codes props
 */
interface RecoveryCodesProps {
	generate: boolean;
	onCancelClick: () => void;
}

/**
 * Recovery codes DTO
 */
interface RecoveryCodesDto {
	recoveryCodes: string[];
}

/**
 * Recovery codes component
 */
function RecoveryCodes(props: RecoveryCodesProps) {
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<AxiosError | null>(null);
	const [recoveryCodes, setRecoveryCodes] = useState<RecoveryCodesDto>({ recoveryCodes: new Array<string>() });

	useEffect(() => {
		(async () => {
			// Load recovery codes data on load
			AxiosHelper.post(`${entityDefinition.baseAjaxRoute}/recovery-codes`, { generate: props.generate })
				.then((resp: AxiosResponse<RecoveryCodesDto>) => {
					setRecoveryCodes(resp.data);
					setIsLoading(false);
				})
				.catch((error: AxiosError) => {
					console.error('Unable to load data...');
					setError(error);
				});
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (error) {
		return <ErrorAlert error={error} />;
	}

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<>
			<h3>Recovery Codes</h3>
			<div className="alert alert-warning" role="alert">
				<p>
					<span className="glyphicon glyphicon-warning-sign" />
					<strong>Put these codes in a safe place.</strong>
				</p>
				<p>
					If you lose your device and don&apos;t have the recovery codes you will lose access to your account.
				</p>
			</div>
			<div className="row">
				<div className="col-md-12">
					{recoveryCodes.recoveryCodes.map((val, i) => {
						return (
							<div key={i}>
								<code className="recovery-code" data-testid={`recovery-code-${i}`}>
									{val}
								</code>
								<br />
							</div>
						);
					})}
				</div>
			</div>
			<br />
			<Link
				to="#"
				className="btn-width-medium btn btn-outline-primary-alt"
				data-testid="leave-recovery-codes-btn"
				onClick={props.onCancelClick}
			>
				Leave. I have these in a safe place.
			</Link>
		</>
	);
}

export default RecoveryCodes;
